import { render, staticRenderFns } from "./detail1.vue?vue&type=template&id=0fdae61f&scoped=true"
import script from "./detail1.vue?vue&type=script&lang=js"
export * from "./detail1.vue?vue&type=script&lang=js"
import style0 from "./detail1.vue?vue&type=style&index=0&id=0fdae61f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdae61f",
  null
  
)

export default component.exports